import { inject } from '@angular/core';
import { LicenseManagerService } from '@uigy/modules/license/license-manager.service';
import { first, map, switchMap } from 'rxjs/operators';
import { AppInitializationService } from '@uigy/shared/services/app-initialization.service';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';

export const UnlicensedGuard: CanActivateFn | CanActivateChildFn = () => {
  const licenseManagerService = inject(LicenseManagerService);
  const appInitializationService = inject(AppInitializationService);
  return appInitializationService.appInitialized.pipe(
    switchMap(() => licenseManagerService.isLicenseInitialized()),
    first(),
    map(isLicensed => !isLicensed),
  );
};
